import { AbstractControl, ValidationErrors } from '@angular/forms';
import { isSameLocalDate } from '../helpers/utils';

export const futureTimeValidator = (
  getStartDate: () => string | null,
): (control: AbstractControl) => ValidationErrors | null => {
  return (control: AbstractControl): ValidationErrors | null => {
    const selectedTime: string = control.value;
    const selectedDate: string | null = getStartDate();

    if (!selectedTime || !selectedDate) return null;

    const [hours, minutes] = selectedTime.split(':').map(Number);
    const selectedDateTime = new Date(selectedDate);
    selectedDateTime.setHours(hours, minutes, 0, 0);

    const now = new Date();

    if (isSameLocalDate(selectedDateTime, now) && selectedDateTime < now) {
      return { time_in_past: true };
    }

    return null;
  };
};
